import React from 'react'
import { DataType, ContextType } from '../types/advanced-grid.types'
import { withGridContext } from '../providers'
import IconButton from '../../buttons/icon-button'

interface Props {
    rowKey?: string | number
    rowData?: DataType
}

/**
 * This component renders the actions button
 * @author Alejandro Quiroz <alejandro.devop@gmail.com>
 * @version 1.0.0
 * @param param0
 * @returns
 */
const ActionsRenderer: React.FC<Props & ContextType> = ({ actions, rowKey, rowData }) => {
    return (
        <>
            {actions &&
                Array.isArray(actions) &&
                actions.map((item, actionKey) => {
                    const { action, icon, key } = item
                    return (
                        <IconButton
                            key={`${key}-${actionKey}-${rowKey}`}
                            icon={icon || 'circle'}
                            onClick={() => (action ? action(rowData) : null)}
                        />
                    )
                })}
        </>
    )
}

export default withGridContext(ActionsRenderer)
